import AppContext from '@/infra/AppContext';

import { LoginResponse } from "@/models/user.model";
import { me } from "@/services/auth.service";
import React, { useEffect } from "react";
import { useState } from "react";
import { isStoredJwt } from './http';
import { useNavigate } from 'react-router-dom';
import { BaseResponseModel } from '@/models/core.model';

export const AppContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [userData, setUserData] = useState<LoginResponse | null>(null);
    const nav = useNavigate();

    useEffect(() => {
        if (!isLoggedIn()) {
            nav('/login'); // Redirect to the login page if not logged in
            return;
        }
        if(!userData){
            getMe();
        }
    }, []);
    
    const getMe = async () =>{
        try {
            const result: BaseResponseModel<LoginResponse> = await me();
            if (result.success) {
                setUserData(result.result);
            }else {
                nav('/login'); 
            }      
        } catch (err) {
            nav('/login'); 
        }

    };

    const isLoggedIn = () => {

        return isStoredJwt();
    };

    const value = {
        userData,
        setUserData,
        isLoggedIn: isLoggedIn,
    };

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};